import React from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from 'styled-components';
import { SubscribeForm as PantheonSubscribeForm } from '@minerva-analytics/pantheon';
import { LUCINA_URL, LUCINA_DOMAIN } from '../../constants';
import { SubscribeContainer, SubscribeFormTheme } from './SubscribeForm.styles';
import { trackFacebookConversion } from '../../utils';

const SubscribeForm = () => {
  const campaignParams = useSelector((state) => state.session.campaignParams);

  const onSuccess = () => {
    trackFacebookConversion(
      `CompleteRegistration`,
      `{"content_name": "email-subscription"}`,
    );
  };

  const referralId = useSelector((state) => state.referral);

  const requestConfig = {
    url: `${LUCINA_URL}/subscribers/`,
    headers: { 'X-Lucina-Domain': LUCINA_DOMAIN },
    data: {
      ...campaignParams,
      ...{ ref: referralId },
    },
  };

  return (
    <SubscribeContainer>
      <ThemeProvider theme={SubscribeFormTheme}>
        <PantheonSubscribeForm
          requestConfig={requestConfig}
          successHandler={onSuccess}
          buttonText="Sign Up"
        />
      </ThemeProvider>
    </SubscribeContainer>
  );
};

export default SubscribeForm;
